import { SigningOfTheStatusType } from "../../types/commonTypes/signingOfTheStatusType";

export const initialSigningOfTheStatusState: SigningOfTheStatusType = {
    actNature: "",
    actDate: "",
    placeSignature: ""
}